import { __ } from '@wordpress/i18n';
import { useState, useEffect } from "@wordpress/element";

import { useBlockProps, InspectorControls, RichText} from '@wordpress/block-editor';
import{Panel, PanelBody } from "@wordpress/components"

import productsPresentations from '../assets/sizes.json';

export default function Edit(props){

    const {attributes, setAttributes, clientId} = props;
    const { blockId, presentations, text, className } = attributes;

    const classNameSpace = 'c-produts-size'
    setAttributes({blockId:clientId});
    
    const saveData = () =>{
        const getAllChecBox = document.querySelectorAll(`.${classNameSpace}__list-checkbox`)
        let selectedElements = []

        getAllChecBox.forEach(element =>{
        
            let data = {}
            if(element.checked){
                data = {
                    id: parseInt(element.id),
                    name: element.name,
                    value: element.value,
                    checked: element.checked,
                    type: element.dataset.type
                }

                selectedElements.push(data);
            }
        }) 

        setAttributes({presentations:selectedElements});
    }

    const mergeOptions = [...presentations, ...productsPresentations];

    const filterOptions = mergeOptions.filter((options, index, self) => {
        return self.findIndex((t) => t.id === options.id) === index;
    });


    return(
        <>
            <InspectorControls>
                <Panel>
                    <PanelBody title={__('Seleccionar opciones de tamaños')}>
                        <ul className={classNameSpace + '__options-list'}>
                            
                            {filterOptions.map(options =>{
                                return(
                                    <li className={classNameSpace + '__list-elements'}>
                                        <label>
                                            <input type="checkbox" 
                                                id={options.id}
                                                name={options.name}
                                                className={classNameSpace + '__list-checkbox'}
                                                data-type={options.type}
                                                onChange={saveData}
                                                value={options.value}
                                                checked={options.checked}
                                            />
                                            <span>{options.name}</span>
                                        </label>
                                    </li>
                                )
                            })}
                        </ul>
                    </PanelBody>
                </Panel>
            </InspectorControls>
            <div { ...useBlockProps({
                className : classNameSpace + '__contents ' + className
            })}>
                <RichText
                    tagName='p'
                    className={classNameSpace + '__title'}
                    placeholder='texto para presentaciones'
                    value={ text }
                    onChange={ ( value ) => setAttributes( {text:value} ) }
                />
                <ul className={classNameSpace + '__list'}>
                    {presentations.length>0 &&
                        presentations.map( presentation =>{
                            return(
                                <li className={classNameSpace + '__items'}>
                                    {presentation.name}
                                </li>
                            )
                        } )
                    }
                </ul>
            </div>
        </>
    );
}
 